(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdw-sortenwahl"] && !Shopify.designMode) return;
  try {
    (function () {
    function legen(items, meldung, text, fertig) {
      var tx = meldung.closest('.pdw-sw').dataset;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || tx.tFehler);
          return j;
        });
      }).then(function () {
        meldung.textContent = text;
        try { document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'pdw' } })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pdw' } })); } catch (e) {}
      }).catch(function (err) {
        meldung.textContent = err.message;
      }).then(fertig);
    }

    function zaehlen(box) {
      var n = box.querySelectorAll('.pdw-sw__wahl[aria-pressed="true"]').length;
      var k = box.querySelector('.pdw-sw__kaufen');
      k.disabled = n === 0;
      k.textContent = n > 1 ? box.dataset.tNKaufen.split('[[anzahl]]').join(n) : box.dataset.tKaufen;
    }

    // Helium (26.10.2026): Preis zur gewaehlten Sorte, Regeln aus assets/pdw-helium-regeln.js.
    var EURO = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
    function sorte(box) {
      var b = box.querySelector('.pdw-sw__wahl[aria-pressed="true"]') || box.querySelector('.pdw-sw__wahl:not([disabled])');
      var vt = b ? b.dataset.vt : box.dataset.vt;
      return vt && vt !== 'Default Title' ? vt : '';
    }
    function heliumZeigen(box) {
      var fs = box.querySelector('.pdw-sw__helium');
      var H = window.pdwHelium;
      if (!fs || !H) return;
      var titel = fs.dataset.titel, vt = sorte(box);
      var gr = H.cm(vt) || H.cm(titel);
      var pos = H.position(fs.dataset.kat, titel + ' ' + vt, gr);
      var ja = fs.querySelector('input[value="ja"]');
      var name = fs.querySelector('.pdw-sw__h-name');
      var note = fs.querySelector('.pdw-sw__h-note');
      H.fuellHolen().then(function (fuell) {
        var f = pos && pos.nr ? fuell[pos.nr] : null;
        var n = H.stueck(titel);
        fs.hidden = false;
        if (f) {
          ja.disabled = false;
          name.textContent = fs.dataset.tPreis.split('[[preis]]').join(EURO.format(f.c * n / 100));
          note.textContent = n > 1
            ? fs.dataset.tMehrere.split('[[anzahl]]').join(n).split('[[preis]]').join(EURO.format(f.c / 100))
            : fs.dataset.tEins;
        } else if (pos && pos.nr) {
          // Fuellartikel nicht im Onlineshop: lieber nichts zeigen als etwas Falsches.
          fs.hidden = true;
          ja.disabled = true;
        } else {
          ja.disabled = true;
          note.textContent = pos && pos.nein ? fs.dataset.tNein.split('[[groesse]]').join(gr) : fs.dataset.tAnfragen;
        }
        if (ja.disabled && ja.checked) fs.querySelector('input[value="nein"]').checked = true;
        fs.querySelector('.pdw-sw__h-abholung').hidden = !ja.checked;
      });
    }
    function mitHelium(box) {
      var ja = box.querySelector('.pdw-sw__helium:not([hidden]) input[value="ja"]');
      return !!(ja && ja.checked && !ja.disabled);
    }
    document.addEventListener('change', function (e) {
      var fs = e.target.closest && e.target.closest('.pdw-sw__helium');
      if (fs) fs.querySelector('.pdw-sw__h-abholung').hidden = !mitHelium(fs.closest('.pdw-sw'));
    });
    // Die Karte ist ein Link: Klicks auf die Helium-Wahl nicht weiterreichen (Auswahl selbst bleibt erlaubt).
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pdw-sw__helium')) e.stopPropagation();
    }, true);

    // Die Karte ist ein Link: Klicks im Schnellbesteller duerfen nicht zur Produktseite fuehren.
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('.pdw-sw button');
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      var box = el.closest('.pdw-sw');
      var meldung = box.querySelector('.pdw-sw__meldung');

      if (el.classList.contains('pdw-sw__direkt')) {
        el.disabled = true;
        legen([{ id: +el.dataset.id, quantity: 1 }], meldung, box.dataset.tLiegt, function () { el.disabled = false; });
      } else if (el.classList.contains('pdw-sw-auf')) {
        var huelle = box.querySelector('.pdw-sw__huelle');
        var offen = el.getAttribute('aria-expanded') === 'true';
        el.setAttribute('aria-expanded', offen ? 'false' : 'true');
        huelle.hidden = offen;
        if (!offen) heliumZeigen(box);
      } else if (el.classList.contains('pdw-sw__wahl')) {
        el.setAttribute('aria-pressed', el.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        meldung.textContent = '';
        zaehlen(box);
        heliumZeigen(box);
      } else if (el.classList.contains('pdw-sw__kaufen') && box.querySelector('.pdw-sw__helium')) {
        var wahl = box.hasAttribute('data-einzeln-helium')
          ? [{ id: +box.dataset.id, vt: box.dataset.vt }]
          : [].slice.call(box.querySelectorAll('.pdw-sw__wahl[aria-pressed="true"]')).map(function (b) { return { id: +b.dataset.id, vt: b.dataset.vt }; });
        if (!wahl.length) return;
        var fs = box.querySelector('.pdw-sw__helium');
        var H = window.pdwHelium;
        var helium = mitHelium(box) && H;
        el.disabled = true;
        (helium ? H.fuellHolen() : Promise.resolve(null)).then(function (fuell) {
          var items = [];
          wahl.forEach(function (w) {
            var vt = w.vt && w.vt !== 'Default Title' ? w.vt : '';
            var f = fuell ? H.fuellung(fs.dataset.kat, fs.dataset.titel, vt, fuell) : null;
            items = items.concat(H ? H.posten(w.id, 1, f, vt ? fs.dataset.titel + ' · ' + vt : fs.dataset.titel) : [{ id: w.id, quantity: 1 }]);
          });
          var text = helium ? fs.dataset.tBeides : wahl.length === 1 ? box.dataset.tLiegt : box.dataset.tNLiegt.split('[[anzahl]]').join(wahl.length);
          return legen(items, meldung, text, function () {
            box.querySelectorAll('.pdw-sw__wahl[aria-pressed="true"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            if (box.hasAttribute('data-einzeln-helium')) el.disabled = false; else zaehlen(box);
          });
        });
      } else if (el.classList.contains('pdw-sw__kaufen')) {
        var gew = [].slice.call(box.querySelectorAll('.pdw-sw__wahl[aria-pressed="true"]'));
        if (!gew.length) return;
        el.disabled = true;
        legen(gew.map(function (b) { return { id: +b.dataset.id, quantity: 1 }; }), meldung,
          gew.length === 1 ? box.dataset.tLiegt : box.dataset.tNLiegt.split('[[anzahl]]').join(gew.length),
          function () {
            gew.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            zaehlen(box);
          });
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
